var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LocalizedLink',{staticClass:"getting-started-progress-bar",attrs:{"to":{ name: 'getting-started' }}},[_c('SteppedProgressBar',{attrs:{"steps":_vm.progressBarSteps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }